<label>Select a file: </label>
<input type="file" (change)="uploadFile($event.target.files)">
